import { 
  HiOutlineViewGrid, 
  HiOutlineDatabase,
  HiOutlineServer
} from 'react-icons/hi';
import { GiCog } from 'react-icons/gi';

export const sidebarConfig = {
  title: 'KSK Dashboard',
  menuItems: [
    {
      path: 'main',
      name: 'Dashboard',
      icon: HiOutlineViewGrid
    },
    {
      path: 'sigfox',
      name: 'Sigfox',
      icon: HiOutlineServer
    }
  ]
}; 